(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/javascripts/utils/date-helper.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/javascripts/utils/date-helper.js'); "use strict";

(function (svs) {
  'use strict';

  svs.player_login.utils.date = {
    format: function format(inDate, withSeconds) {
      var zeroPad = function zeroPad(n) {
        return n < 10 ? "0".concat(n) : n;
      };

      try {
        return "".concat(inDate.getFullYear(), "-").concat(zeroPad(inDate.getMonth() + 1), "-").concat(zeroPad(inDate.getDate()), " ").concat(zeroPad(inDate.getHours()), ":").concat(zeroPad(inDate.getMinutes())).concat(withSeconds ? ":".concat(zeroPad(inDate.getSeconds())) : '');
      } catch (e) {
        return '';
      }
    },
    parseLastLoginTime: function parseLastLoginTime(inDate, withSeconds) {
      return "".concat(inDate.substr(0, 10), " ").concat(withSeconds ? inDate.substr(11, 8) : inDate.substr(11, 5));
    }
  };
})(svs);
 })(window);